import React, {Fragment,} from 'react'
import {Link,} from 'react-router-dom'
import './style.css'

export default function TechnologyServiceCard(props) {
    const {data} = props;
    return (
        <div className='TechnologyServiceCard'>
            <img className='TechnologyServiceCard_BackgroundImg' src={data.address}/>
            <div className='TechnologyServiceCard_BackgroundImg2'>
                <div className='TechnologyServiceCard_ContentImg1'/>
                <div className='TechnologyServiceCard_ContentImg2'/>
            </div>
            <div className='TechnologyServiceCard_Content'>
                <Link to={data.location}>
                    <div className='TechnologyServiceCard_ContentTitle'>
                        <div className='TechnologyServiceCard_ContentTitleText'>{data.title}</div>
                        <div className='TechnologyServiceCard_ContentTitleBottom'/>
                    </div>
                </Link>
                <div className='TechnologyServiceCard_ContentIntroduce'>
                    <div className="TechnologyServiceCard_ContentIntroduce_Content">
                        {data.introduce}
                    </div>
                </div>
            </div>
        </div>
    )
}